import {Injectable} from '@angular/core';

import {Rest, RestResponse, RestResponseSuccess} from '../common/server-actions/rest';
import {PromiseService} from 'ac-infra';

export interface Workspace {
    id?: string | number;
    name?: string;
    description?: string;
    isActive?: boolean;
    autoSave?: boolean;
    data?: any;
}

@Injectable({
    providedIn: 'root'
})
export class WorkspaceRestService extends Rest {

    constructor() {
        super({
            url: 'settings/workspaces'
        });
    }

    createWorkspace(workspace: Workspace) {
        const defer = PromiseService.defer();
        this.add(undefined, undefined, workspace, this.url, undefined, defer);
        return defer.promise.then(({data}) => data);
    }

    updateWorkspaceById(id, workspace: Workspace, {success = (...args) => null, failure = (...args) => null} = {}) {
        const defer = PromiseService.defer();
        this.edit(success, failure, workspace, id, this.url, defer);
        return defer.promise.then(({data}) => data);
    }

    getWorkspaceById(workspaceId, success = (...args): any => null, failure = (...args) => null) {
        return this.getById({
            id: workspaceId,
            success: (res) => success(res.data),
            failure,
        });
    }

    async getWorkspaceState() {
        return await this.get({
            parameters: {
                fields: ['name', 'isActive', 'autoSave', 'data'],
            },
        }).then(({data}: RestResponseSuccess) => data.workspaces);
    }

    getWorkspaceStateByFilter({filter = undefined, success = (...args) => null, failure = (...args) => null} = {}) {
        this.get({
            parameters: {
                filter,
                fields: ['name', 'isActive', 'autoSave', 'description'],
            },
        }).then((res: RestResponseSuccess) => success(res.data.workspaces)).catch(failure);
    }
}
